<template>
  <!--
      作者：kmdshop
      时间：2020-06-01
      描述：插件中心-应急物资-添加
    -->
    <el-dialog
    title="添加应急物资"
    :visible.sync="dialogVisible"
    @close="dialogFormVisible"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    width="70%"
  >

  <div class="product-add pb50">
    <el-form size="small" :model="form" ref="form" :rules="rules" label-width="100px">
      <!-- 基本信息 -->
      <el-row :gutter="20">
        <el-col :span="8">
          <el-form-item label="责任部门" prop="responsible_department" required>
            <el-select
              v-model="form.responsible_department"
              placeholder="请选择责任部门"
              clearable
              filterable
              style="width: 100%;"
            >
              <el-option label="安全保卫部" value="安全保卫部" />
              <el-option label="后勤保障部" value="后勤保障部" />
              <el-option label="生产管理部" value="生产管理部" />
              <el-option label="设备管理部" value="设备管理部" />
              <el-option label="行政办公室" value="行政办公室" />
              <el-option label="应急管理部" value="应急管理部" />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="责任人" prop="responsible_person" required>
            <el-input v-model="form.responsible_person" placeholder="请输入责任人"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="联系电话" prop="contact_phone" required>
            <el-input 
              v-model="form.contact_phone" 
              placeholder="请输入联系电话"
              maxlength="11"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>

      <!-- 物资列表 -->
      <el-form-item label="物资列表" prop="supplies" required>
        <div class="supplies-table-container">
          <el-table
            :data="form.supplies"
            size="small"
            border
            style="width: 100%; margin-bottom: 15px;"
          >
            <el-table-column type="index" label="序号" width="60" align="center" />
            
            <el-table-column prop="name" label="物资名称" width="180" align="center">
              <template slot-scope="scope">
                <el-input
                  v-model="scope.row.name"
                  placeholder="请输入物资名称"
                  size="mini"
                  clearable
                />
              </template>
            </el-table-column>
            
            <el-table-column label="物资数量" width="150" align="center">
              <template slot-scope="scope">
                <div style="display: flex; align-items: center;">
                  <el-input-number
                    v-model="scope.row.quantity"
                    :min="1"
                    :max="999999"
                    size="mini"
                    controls-position="right"
                    style="flex: 1;"
                  />
                  <el-select
                    v-model="scope.row.unit"
                    size="mini"
                    style="width: 70px; margin-left: 5px;"
                  >
                    <el-option label="个" value="个" />
                    <el-option label="件" value="件" />
                    <el-option label="台" value="台" />
                    <el-option label="套" value="套" />
                    <el-option label="箱" value="箱" />
                    <el-option label="瓶" value="瓶" />
                    <el-option label="盒" value="盒" />
                  </el-select>
                </div>
              </template>
            </el-table-column>
            
            <el-table-column prop="storage_standard" label="储存维护标准" width="180" align="center">
              <template slot-scope="scope">
                <el-select
                  v-model="scope.row.storage_standard"
                  placeholder="请选择"
                  size="mini"
                  clearable
                  style="width: 100%;"
                >
                  <el-option label="是否在有效期内" value="是否在有效期内" />
                  <el-option label="定期检查维护" value="定期检查维护" />
                  <el-option label="防潮防湿" value="防潮防湿" />
                  <el-option label="防火防盗" value="防火防盗" />
                  <el-option label="避光保存" value="避光保存" />
                  <el-option label="恒温保存" value="恒温保存" />
                </el-select>
              </template>
            </el-table-column>
            
            <el-table-column prop="is_valid" label="是否有效" width="120" align="center">
              <template slot-scope="scope">
                <el-select
                  v-model="scope.row.is_valid"
                  size="mini"
                  style="width: 100%;"
                >
                  <el-option :value="1" label="是" />
                  <el-option :value="0" label="否" />
                </el-select>
              </template>
            </el-table-column>
            
            <el-table-column prop="storage_location" label="存放位置" width="180" align="center">
              <template slot-scope="scope">
                <el-input
                  v-model="scope.row.storage_location"
                  placeholder="例如：办公室、仓库"
                  size="mini"
                  clearable
                />
              </template>
            </el-table-column>
            
            <el-table-column label="操作" width="80" align="center" fixed="right">
              <template slot-scope="scope">
                <el-button
                  type="danger"
                  icon="el-icon-delete"
                  size="mini"
                  circle
                  @click="removeSupplies(scope.$index)"
                />
              </template>
            </el-table-column>
          </el-table>
          
          <div style="text-align: center;">
            <el-button type="primary" size="small" @click="addSupplies">
              <i class="el-icon-plus"></i> 添加物资
            </el-button>
          </div>
        </div>
      </el-form-item>


    
      <!--提交-->
      <div class="common-button-wrapper">
        <el-button size="small" type="info" @click="cancelFunc">取消</el-button>
        <el-button size="small" type="primary" @click="onSubmit" :loading="loading">提交</el-button>
      </div>
    </el-form>
    
    <!--业务附件上传组件-->
    <Upload v-if="isProductUpload" :config="{ total: 9 }" :isupload="isProductUpload" @returnImgs="returnProductImgsFunc">上传图片</Upload>
 </div>
</el-dialog>
  
</template>

<script>
import Ma_emergency_suppliesApi from '@/api/ma_emergency_supplies.js';
import Upload from '@/components/file/Upload';

export default {
  components: {
    /*图片上传*/
    Upload: Upload,
  },
  data() {
    // 验证联系电话
    const validatePhone = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('请输入联系电话'));
      }
      const phoneReg = /^1[3-9]\d{9}$/;
      if (!phoneReg.test(value)) {
        callback(new Error('请输入正确的手机号码'));
      } else {
        callback();
      }
    };
    
    // 验证物资列表
    const validateSupplies = (rule, value, callback) => {
      if (!value || value.length === 0) {
        return callback(new Error('请至少添加一个物资'));
      }
      
      for (let i = 0; i < value.length; i++) {
        const item = value[i];
        if (!item.name) {
          return callback(new Error(`第 ${i + 1} 行的物资名称不能为空`));
        }
        if (!item.quantity || item.quantity < 1) {
          return callback(new Error(`第 ${i + 1} 行的物资数量必须大于0`));
        }
      }
      callback();
    };
    
    return {
      /*是否上传图片*/
      isupload: false,
      isImg: false,  
      /*富文本配置*/
      ueditor: {
        text: '',
        config: {
          initialFrameWidth: 400,
          initialFrameHeight: 500
        }
      },
      /*form表单数据*/
      form: {
        name: '',
        responsible_department: '',
        responsible_person: '',
        contact_phone: '',
        sort: 50,
        intro: '',
        supplies: []  // 物资列表数组
      },
      loading: false,
      /*验证规则*/
      rules: {
        responsible_department: [
          { required: true, message: '请选择责任部门', trigger: 'change' }
        ],
        responsible_person: [
          { required: true, message: '请输入责任人', trigger: 'blur' }
        ],
        contact_phone: [
          { required: true, validator: validatePhone, trigger: 'blur' }
        ],
        supplies: [
          { required: true, validator: validateSupplies, trigger: 'change' }
        ]
      },
      dialogVisible: false,
      iscategorya: false,
      excludeIds: [],
      isProductUpload: false,
      code: "album"
    };
  },
  created() {
    this.dialogVisible = this.open_add;
    // 初始化一个物资
    this.addSupplies();
  },
  props: ["open_add"],
  methods: {
    /*添加物资行*/
    addSupplies() {
      this.form.supplies.push({
        name: '',
        quantity: 1,
        unit: '个',
        storage_standard: '是否在有效期内',
        is_valid: 1,
        storage_location: '办公室、仓库'
      });
    },
    
    /*删除物资行*/
    removeSupplies(index) {
      if (this.form.supplies.length <= 1) {
        this.$message.warning('至少需要保留一个物资');
        return;
      }
      this.form.supplies.splice(index, 1);
    },

    chooseCategory(){
      this.iscategorya = true;
    },
    
    /*上传*/
    openUpload(e) {
      this.isupload = true;
    },

    /*关闭弹窗*/
    dialogFormVisible(result) {
      this.$emit("close", { openDialog: false, "type": "" });
    },
    
    cancelFunc(){//取消
      this.dialogFormVisible("error")
    },

    onSubmit() {
      let self = this;
      let form = self.form;
      self.$refs.form.validate(valid => {
        if (valid) {
          self.loading = true;
          
          // 处理提交数据
          const submitData = {
            responsible_department: form.responsible_department,
            responsible_person: form.responsible_person,
            contact_phone: form.contact_phone,
            sort: form.sort,
            supplies: JSON.stringify(form.supplies),  // 将物资数组转为JSON字符串
            create_time: Math.floor(Date.now() / 1000),
            update_time: Math.floor(Date.now() / 1000)
          };
          
          Ma_emergency_suppliesApi.add(submitData, true)
            .then(data => {
              self.loading = false;
              self.$message({
                message: data.msg,
                type: 'success'
              });
              self.dialogFormVisible("error")
            })
            .catch(error => {
              self.loading = false;
            });
        }
      });
    },

    /*取消添加，返回任务列表*/
    cancelFunc() {
      this.$emit("close", { openDialog: false, "type": "" });
    },
    
    /*打开上传图片*/
    openProductUpload: function (code) {
      this.isProductUpload = true;
      this.code = code
    },

    /*上传业务附件*/
    returnProductImgsFunc(e) {
      if(this.code == 'album'){
        if (e != null) {
          let imgExpt = ["bmp", "jpg", "jpeg", "png", "gif"];
          let prevent = false;
          console.log(typeof imgExpt);
          e.forEach((element) => {
            let data_array = element.file_path.split(".");
            let ext = data_array[data_array.length - 1];
            imgExpt.forEach((e) => {
              if (e === ext) {
                prevent = true
                return false
              }
            });
          });

          if (!prevent) {
            this.$message.error("图片类型有误,请选择正确的图片格式");
            return false;
          }

          let imgs = this.form.image.concat(e);
          this.$set(this.form, "image", imgs);
        }
      } else {
        if (e != null) {
          let imgExpt = ["bmp", "jpg", "jpeg", "png", "gif"];
          let prevent = false;
          console.log(typeof imgExpt);
          e.forEach((element) => {
            let data_array = element.file_path.split(".");
            let ext = data_array[data_array.length - 1];
            imgExpt.forEach((e) => {
              if (e === ext) {
                prevent = true
                return false
              }
            });
          });

          if (!prevent) {
            this.$message.error("图片类型有误,请选择正确的图片格式");
            return false;
          }

          let imgs = this.form.bannar.concat(e);
          this.$set(this.form, "bannar", imgs);
        }
      }
      
      this.isProductUpload = false;
    },

    /*删除业务附件*/
    deleteImg(index,code) {
      if(code == 'album'){
        this.form.image.splice(index, 1);
      }else if(code == 'bannar'){
        this.form.bannar.splice(index, 1);
      }
    },
  }
};
</script>

<style scoped>
.supplies-table-container {
  border: 1px solid #ebeef5;
  border-radius: 4px;
  padding: 15px;
  background-color: #fafafa;
}

::v-deep .el-table .cell {
  padding: 5px;
}

::v-deep .el-input-number--mini {
  width: 100px;
}

.pb50 {
  padding-bottom: 50px;
}

.max-w460 {
  max-width: 460px;
}
</style>


// WEBPACK FOOTER //
// src/views/plus/ma_emergency_supplies/index/part/add.vue